import type { CanvasDraftRuntimeFingerprint } from '@hector/shared-types';

/**
 * Build identity of the browser code that serialised a Canvas DOCX.
 *
 * This intentionally contains only deploy/runtime versions. Document content,
 * the user agent, and case metadata remain out of the forensic record.
 */
export const canvasDraftRuntimeFingerprint: CanvasDraftRuntimeFingerprint = {
  applicationVersion: __HECTOR_APPLICATION_VERSION__,
  superdocReactVersion: __HECTOR_SUPERDOC_REACT_VERSION__,
};
